import React, {useRef, useState} from "react";
import {Button, Overlay, Tooltip} from "react-bootstrap";


interface TooltipButtonProps {
    onClick: () => void
}

function TooltipButton(props: TooltipButtonProps) {
    const [show, setShow] = useState(false);
    const target = useRef(null);
    const onClick = () => {
        props.onClick();
        setShow(true);
        setTimeout(() => {
            setShow(false);
        }, 3000);
    };

    return (
        <>
            <Button
                variant="icon"
                style={{display: "inline-flex", alignItems: "flex-end"}}
                ref={target}
                onClick={onClick}>
                <i className="icon icon-chain"/>
            </Button>
            <Overlay target={target.current} show={show} placement="right">
                {(props) => (
                    <Tooltip {...props}>
                        Copied!
                    </Tooltip>
                )}
            </Overlay>
        </>
    );
}

export default TooltipButton;